export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    py: 6,
    px: 3,
    textAlign: 'center',
  },
  icon: {
    fontSize: 48,
    color: 'primary.main',
    mb: 2,
  },
  title: {
    fontWeight: 600,
    color: 'text.primary',
    mb: 0.5,
  },
  description: {
    color: 'text.secondary',
  },
};
